import { ref } from 'vue'
import { defineStore } from 'pinia'
import axios from '@/plugins/axios.js';
import { generalStore } from '.';

export const newStore = defineStore('new', () => {
    var news = ref({});
    var detailNew = ref(null);
    const store = generalStore();

    /*NEWS*/
    const getDetailNew = () => {
        return detailNew.value;
    }

    const setDetailNew = (value) => {
        if (value != null) {
            if (getDetailNew() != null) {
                detailNew.value['content'] = value[0]['content'];
                detailNew.value['author'] = value[0]['author'];
                detailNew.value['reserves'] = value[0]['reserves'];
                return
            }
            detailNew.value = value;
            return
        }
        detailNew.value = null;
    }


    const setNews = (data) => {
        news.value = data;
    }

    const getNews = () => {
        return news.value;
    }

    /**
     * Function used to render information of the news in the News page
     * @returns All news
     */
    const getAllNews = async () => {
        store.load = true;
        try {
            await axios.get('/news.php', {
                params: {
                    type: 'news'
                }
            }, {
            }).then(response => {
                if (response.status == 200) {
                    setNews(response['data'])
                } else {
                    console.log('redirigir a página de "NO ENCONTRADO"');
                }
            })
        } catch (error) {
            console.error("Hubo un error en la solicitud: ", error);
        } finally {
            store.load = false;
            return getNews();
        }
    }


    /**
     * Function used to search detail a specific new
     * @param {*} id new id
     * @returns detail of the new
     */
    const getDetailNews = async (id) => {
        try {
            await axios.get('/news.php', {
                params: {
                    id,
                    type: 'detail'
                }
            }, {
            }).then(response => {
                if (response.status == 200) {
                    setDetailNew(response.data)
                } else {
                    console.log('redirigir a página de "NO ENCONTRADO"');
                }
            })
        } catch (error) {
            console.error("Hubo un error en la solicitud: ", error);
        } finally {
            return getDetailNew();
        }
    }

    /**
     * Function used to search the complete new with the id new
     * @param {*} id new id
     * @returns complete of the new
     */
    const getCompleteNews = async (id) => {
        try {
            await axios.get('/news.php', {
                params: {
                    id,
                    type: 'complete'
                }
            }, {
            }).then(response => {
                if (response.status == 200) {
                    setDetailNew(response.data)
                } else {
                    console.log('redirigir a página de "NO ENCONTRADO"');
                }
            })
        } catch (error) {
            console.error("Hubo un error en la solicitud: ", error);
        } finally {
            return getDetailNew();
        }
    }

    const registerClick = async (id) => {
        try {
            await axios.put('/news.php', {
                'id': id,
                'action': 'view'
            }).then(response => {
                if (response.status == 200) {
                    console.log('Acceso registrado')
                }
            })
        } catch (error) {
            console.log('Acceso no registrado')
        }
    }

    return {
        getDetailNew,
        setDetailNew,
        getAllNews,
        getDetailNews,
        getCompleteNews,
        getNews,
        registerClick
    }
})